import gms from './theme_gms'
import horus from './theme_horus'
import msmc from './theme_msmc'
import ssc from './theme_ssc'
import ipsn from './theme_ipsn'
import ha from './theme_ha'
import galsim from './theme_galsim'

export default { gms, horus, ssc, ipsn, ha, msmc, galsim }
